import {createWorker} from '@github-ui/create-worker'
import workerUrl from './find-in-file.worker?worker&url'

export function createFindInFileWorker() {
  return createWorker(workerUrl, {type: 'module'})
}
